export default (errorMessage = 'Informação Obrigatória') => (value) => {
  if (Array.isArray(value) && !value.length) throw errorMessage
  if ([null, undefined].includes(value)) throw errorMessage
  if (!String(value).trim()) throw errorMessage
}
